'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SAVE_OFFER_MODAL = exports.acceptSaveOffer = exports.closeSaveOffer = exports.openSaveOffer = exports.SUBSCRIPTION_CHANGE_REQUEST = exports.ACCEPT_SAVE_OFFER = exports.CLOSE_SAVE_OFFER_MODAL = exports.OPEN_SAVE_OFFER_MODAL = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

exports.doOpenSaveOfferModal = doOpenSaveOfferModal;
exports.doCloseSaveOfferModal = doCloseSaveOfferModal;
exports.doSwitchPlanToSaveOffer = doSwitchPlanToSaveOffer;
exports.watchSaveOfferSagas = watchSaveOfferSagas;

var _sagaTools = require('@classpass/saga-tools');

var _effects = require('redux-saga/effects');

var _bound = require('redux/saga/entities/bound');

var _modals = require('redux/modules/modals');

var _page = require('redux/modules/page');

var _reactRouterRedux = require('react-router-redux');

var _planChangeEffectiveDates = require('constants/plan-change-effective-dates');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(doOpenSaveOfferModal),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(doCloseSaveOfferModal),
    _marked3 = /*#__PURE__*/_regenerator2.default.mark(doSwitchPlanToSaveOffer),
    _marked4 = /*#__PURE__*/_regenerator2.default.mark(watchSaveOfferSagas);

var OPEN_SAVE_OFFER_MODAL = exports.OPEN_SAVE_OFFER_MODAL = 'OPEN_SAVE_OFFER_MODAL';
var CLOSE_SAVE_OFFER_MODAL = exports.CLOSE_SAVE_OFFER_MODAL = 'CLOSE_SAVE_OFFER_MODAL';
var ACCEPT_SAVE_OFFER = exports.ACCEPT_SAVE_OFFER = 'ACCEPT_SAVE_OFFER';
var SUBSCRIPTION_CHANGE_REQUEST = exports.SUBSCRIPTION_CHANGE_REQUEST = 'SUBSCRIPTION_CHANGE_REQUEST';
var openSaveOffer = exports.openSaveOffer = function openSaveOffer() {
  return { type: OPEN_SAVE_OFFER_MODAL };
};
var closeSaveOffer = exports.closeSaveOffer = function closeSaveOffer() {
  return { type: CLOSE_SAVE_OFFER_MODAL };
};
var acceptSaveOffer = exports.acceptSaveOffer = function acceptSaveOffer() {
  return { type: ACCEPT_SAVE_OFFER };
};
var SAVE_OFFER_MODAL = exports.SAVE_OFFER_MODAL = 'SaveOfferModal';

function doOpenSaveOfferModal(props) {
  return _regenerator2.default.wrap(function doOpenSaveOfferModal$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.put)((0, _modals.showModal)(SAVE_OFFER_MODAL, props));

        case 2:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function doCloseSaveOfferModal() {
  return _regenerator2.default.wrap(function doCloseSaveOfferModal$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.all)([(0, _effects.put)((0, _modals.hideModal)(SAVE_OFFER_MODAL)), (0, _effects.put)((0, _reactRouterRedux.replace)('/settings/membership'))]);

        case 2:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function doSwitchPlanToSaveOffer(client) {
  var _ref, _ref2, profile, offer;

  return _regenerator2.default.wrap(function doSwitchPlanToSaveOffer$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          _context3.next = 3;
          return (0, _effects.all)([(0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.userProfile, [client]), (0, _effects.put)((0, _page.toggleFlag)(SUBSCRIPTION_CHANGE_REQUEST))]);

        case 3:
          _ref = _context3.sent;
          _ref2 = (0, _slicedToArray3.default)(_ref, 1);
          profile = _ref2[0];
          _context3.next = 8;
          return (0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.saveOffer, [client, profile.id]);

        case 8:
          offer = _context3.sent;
          _context3.next = 11;
          return (0, _effects.call)(client.subscription.create, profile.id, {
            msa_id: offer.msa_id,
            plan_id: offer.id,
            effective: _planChangeEffectiveDates.EFFECTIVE_NEXT_CYCLE
          });

        case 11:
          _context3.next = 13;
          return (0, _effects.call)(doOpenSaveOfferModal, { planChangeSuccessful: true });

        case 13:
          _context3.next = 19;
          break;

        case 15:
          _context3.prev = 15;
          _context3.t0 = _context3['catch'](0);
          _context3.next = 19;
          return (0, _effects.put)((0, _page.toggleFlag)(SUBSCRIPTION_CHANGE_REQUEST));

        case 19:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this, [[0, 15]]);
}

function watchSaveOfferSagas(client) {
  return _regenerator2.default.wrap(function watchSaveOfferSagas$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.fork)(_effects.takeEvery, OPEN_SAVE_OFFER_MODAL, doOpenSaveOfferModal);

        case 2:
          _context4.next = 4;
          return (0, _effects.fork)(_effects.takeEvery, CLOSE_SAVE_OFFER_MODAL, doCloseSaveOfferModal);

        case 4:
          _context4.next = 6;
          return (0, _effects.fork)(_effects.takeEvery, ACCEPT_SAVE_OFFER, doSwitchPlanToSaveOffer, client);

        case 6:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this);
}